import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const SearchSelectMd = (props) => {
    const optionsList = [];
    let firstMenuItem = null;

    const {options, useNullableFirstItem} = props;

    options.forEach((option, index) => {
        optionsList.push((<MenuItem
            key={index}
            value={option.userId}
            primaryText={`${option.techId} - ${option.userId}`}/>));
    });

    if (useNullableFirstItem) {
        firstMenuItem = (<MenuItem value={null} primaryText=""/>);
    }

    return (
        <SelectField
            fullWidth
            floatingLabelText={props.labelText}
            value={props.value}
            onChange={props.onChange}
            style={props.style}>
            {firstMenuItem}
            {optionsList}
        </SelectField>
    );
};

SearchSelectMd.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    labelText: PropTypes.string,
    style: PropTypes.object,
    useNullableFirstItem: PropTypes.bool
};

export default SearchSelectMd;


// WEBPACK FOOTER //
// ./src/components/tech/SearchSelectMd.js